import axios from 'axios';

export const getVersion = () => {
  return axios.get('/v1/version.json')
}



// WEBPACK FOOTER //
// ./src/backend/version.js